export function LockIcon() {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.12516 7.19005V5.82031C4.12516 3.33503 6.13988 1.32031 8.62516 1.32031C11.1104 1.32031 13.1252 3.33503 13.1252 5.82031V7.19005C13.8684 7.24558 14.3523 7.38565 14.706 7.73945C15.2918 8.32525 15.2918 9.26805 15.2918 11.1536C15.2918 13.0392 15.2918 13.982 14.706 14.5678C14.1202 15.1536 13.1774 15.1536 11.2918 15.1536H5.9585C4.07288 15.1536 3.13007 15.1536 2.54428 14.5678C1.9585 13.982 1.9585 13.0392 1.9585 11.1536C1.9585 9.26805 1.9585 8.32525 2.54428 7.73945C2.89804 7.38565 3.382 7.24558 4.12516 7.19005ZM5.12516 5.82031C5.12516 3.88732 6.69217 2.32031 8.62516 2.32031C10.5582 2.32031 12.1252 3.88732 12.1252 5.82031V7.15605C11.8698 7.15365 11.5928 7.15365 11.2918 7.15365H5.9585C5.65749 7.15365 5.3805 7.15365 5.12516 7.15605V5.82031ZM8.62516 9.32031C8.9013 9.32031 9.12516 9.54418 9.12516 9.82031V12.487C9.12516 12.7631 8.9013 12.987 8.62516 12.987C8.34903 12.987 8.12516 12.7631 8.12516 12.487V9.82031C8.12516 9.54418 8.34903 9.32031 8.62516 9.32031Z'
        fill='#021542'
      />
    </svg>
  )
}
